const price = (state = 0, action) => {
    switch(action.type) {
        case 'price':
            return action.payload;
        default:
            return state;
    }
}

export default price;